import React from 'react';
import { WifiOff } from 'lucide-react';

/**
 * Offline indicator banner - shows when user loses connection
 */
export const OfflineBanner = ({ pendingScores = 0 }) => {
  return (
    <div className="fixed top-0 left-0 right-0 bg-yellow-500 text-black py-2 px-4 text-center z-50 flex items-center justify-center gap-2">
      <WifiOff className="w-4 h-4" />
      <span className="text-sm font-medium">
        You're offline. 
        {pendingScores > 0 && ` ${pendingScores} score(s) will sync when you're back online.`}
        {pendingScores === 0 && ' Scores will be saved locally.'}
      </span>
    </div>
  );
};

export default OfflineBanner;
